<script>
import {flatCategories} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Category'

export default {
  name: "CategoriesWrapper",
  data() {
    return {
      categories: [],
      category: [],
    }
  },
  props: {
    slicer: {
      default: Infinity,
    },
    singleCategory: {
      default: null
    },
  },
  methods: {
    imageHandler(category, alternativeImage) {
      if (category.image === null) {
        return alternativeImage;
      }
      return category.image
    },
    flatCategories,
    setLinkType(category, linkType) {
      return linkType === 'blog'
          ?
          {name: 'Posts', query: {category: category.slug}}
          :
          {name: 'SingleCategory', params: {slug: category.slug}}
    },
    clearRouter(linkType) {
      if (linkType == 'blog') {
        return {name: 'Posts'}
      } else {
        return {name: 'SingleCategory'}
      }
    }
  },
  render() {

    let categories_data = []

    if (this.singleCategory != null) {

      categories_data = this.category.length != 0 ? this.category.data.data : []
    } else {
      categories_data = this.categories.length != 0 ? this.categories.data.data.slice(0, this.slicer) : []
    }

    return this.$scopedSlots.default({
      categories: categories_data,
      imageHandler: this.imageHandler,
      flatCategories: this.flatCategories,
      setLinkType: this.setLinkType,
      clearRouter: this.clearRouter
    });

  },
  async mounted() {
    if (this.singleCategory != null) {
      const form = {categories: [this.singleCategory]}
      this.category = await this.$store.dispatch("Category/getCategoryWithSlug", form);
    } else {
      this.categories = await this.$store.dispatch("Category/getCategoriesWithoutState");
    }
  }
}
</script>
